import type { AuthProvider } from 'react-admin';
import { signOut, supabase } from '../supabase';

// /admin sits behind <RequireSession>; this only maps the Supabase session into react-admin.
export const authProvider: AuthProvider = {
    login: async () => undefined,
    logout: async () => {
        await signOut();
        window.location.assign('/auth?redirectToPath=/admin');
        return false;
    },
    checkAuth: async () => {
        const { data } = await supabase.auth.getSession();
        if (!data.session) {
            throw new Error('Not signed in');
        }
    },
    checkError: async (error: { status?: number }) => {
        // 403 "invalid claim" (no UserManagement.Admin role) stays signed in; react-admin shows the message.
        if (error.status === 401) {
            throw error;
        }
    },
    getIdentity: async () => {
        const { data } = await supabase.auth.getSession();
        const user = data.session?.user;
        return { id: user?.id ?? '', fullName: user?.user_metadata?.full_name ?? user?.email };
    },
    getPermissions: async () => ''
};
